import Worker from './Worker';

export default Worker;
